<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useLocalizedRouter } from '@/composables/localizedRouter'
import UserAccountButton from './UserAccountButton/UserAccountButton.vue'
import { LOGIN_MODAL } from '@/types/Modals'
import { useAuthStore } from "@/stores/useAuthStore"
import { useModalsStore } from "@/stores/useModalsStore"
import { storeToRefs } from "pinia"

withDefaults(defineProps<{
  inline?: boolean,
}>(), {
  inline: false,
})

const authStore = useAuthStore()
const { isAuthenticated } = storeToRefs(authStore)
const router = useRouter()
const { localizedRoute } = useLocalizedRouter()
const { toggle } = useModalsStore()

async function onUserBtnClick() {
  if (isAuthenticated.value) {
    await router.push(localizedRoute({ name: 'customer-account' }))

    return
  }

  toggle(LOGIN_MODAL, true)
}
</script>

<template>
  <UserAccountButton :inline="inline"
                     :logged-in="isAuthenticated"
                     @click="onUserBtnClick"/>
</template>
